<template>
  <div class="marketing">
    <div class="marketing-title">
      LEARN FROM REAL MARKETING KILLERS.
    </div>
    <p v-if="$vuetify.breakpoint.smAndDown" class="marketing-desc">
      Lorem ipsum dolor sit amet,
    </p>
    <p v-else class="marketing-desc">
      LOREM IPSUM DOLOR SIT AMET, CONSETETUR SADIPSCING ELITR, SED DIAM NONUMY
      EIRMOD
    </p>
    <div v-if="$vuetify.breakpoint.smAndDown" class="marketing-slider">
      <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide v-for="(n, idx) in 10" :key="idx">
          <div class="marketing-item-wrapper">
            <div class="marketing-item">
              <div class="marketing-item-top">
                <img
                  v-lazy="require('@/assets/img/slider-item-1.jpg')"
                  alt=""
                />
              </div>
              <div class="marketing-item-bottom">
                <IconYoutube />
                <p class="marketing-item-title">
                  SEE HOW WE INCREASED TURNOVER BY 30%
                </p>
                <router-link to="/" class="marketing-item-url">
                  VIEW THE STUDY CASE
                </router-link>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-button-prev marketing-prev" slot="button-prev">
        <IconSliderPrev />
      </div>
      <div class="swiper-button-next marketing-next" slot="button-next">
        <IconSliderNext />
      </div>
      <div class="swiper-pagination" slot="pagination"></div>
    </div>
    <div v-else :style="largeScreenContainer">
      <v-container>
        <div class="marketing-slider">
          <swiper ref="mySwiper" :options="swiperOptions">
            <swiper-slide v-for="(n, idx) in 10" :key="idx">
              <div class="marketing-item-wrapper">
                <div class="marketing-item">
                  <div class="marketing-item-top">
                    <img
                      v-lazy="require('@/assets/img/slider-item-1.jpg')"
                      alt=""
                    />
                  </div>
                  <div class="marketing-item-bottom">
                    <IconYoutube />
                    <p class="marketing-item-title">
                      SEE HOW WE INCREASED TURNOVER BY 30%
                    </p>
                    <router-link to="/" class="marketing-item-url">
                      VIEW THE STUDY CASE
                    </router-link>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev marketing-prev" slot="button-prev">
            <IconSliderPrev />
          </div>
          <div class="swiper-button-next marketing-next" slot="button-next">
            <IconSliderNext />
          </div>
          <div class="swiper-pagination" slot="pagination"></div>
        </div>
      </v-container>
    </div>

    <v-btn
      v-if="!$vuetify.breakpoint.smAndDown"
      color="#600DFF"
      class="hero-cta white--text"
      style="height:55px;margin-top:66px;"
      elevation="0"
    >
      GET STARTED WITH TRIANGE TODAY!
    </v-btn>
  </div>
</template>

<script>
export default {
  data() {
    return {
      swiperOptions: {
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".marketing-next",
          prevEl: ".marketing-prev",
        },
        loop: true,
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
        },
        autoplay: {
          delay: 2500,
        },
      },
    };
  },
  components: {
    IconYoutube: () => import("@/components/icons/IconYoutube"),
    IconSliderPrev: () => import("@/components/icons/IconSliderPrev"),
    IconSliderNext: () => import("@/components/icons/IconSliderNext"),
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
};
</script>

<style lang="scss">
.marketing {
  text-align: center;
  color: #000;
  padding: 80px 0;

  &-slider {
    position: relative;
    padding: 0 80px;
    .swiper-pagination {
      display: none;
    }
    .swiper-slide {
      // width: 344px !important;
    }
  }

  &-title {
    font-size: 40px;
    font-weight: bold;
    margin-bottom: 43px;
  }
  &-desc {
    font-size: 20px;
    margin-bottom: 65px !important;
  }
  &-item {
    border: 1px solid rgba(112, 112, 112, 0.17);
    max-width: 344px;
    margin: 0 auto;

    &-top {
      height: 214px;

      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
    }

    &-bottom {
      padding: 20px 16px;
      text-align: left;
    }

    &-title {
      font-size: 30px;
      margin-top: 30px;
      margin-bottom: 25px;
      color: #000;
    }

    &-url {
      color: #6021ff !important;
      font-size: 20px;
    }

    &-wrapper {
    }
  }

  .swiper-button-next,
  .swiper-button-prev {
    width: 80px !important;
    height: 80px !important;
    outline: none;

    &::after {
      display: none;
    }
  }
}

@include smMax {
  .marketing {
    padding-top: 0;
    &-title {
      font-size: 38px;
    }
    &-item {
      max-width: 344px;
      margin: 0 auto;
    }
    &-slider {
      padding: 0;
      .marketing-next,
      .marketing-prev {
        display: none;
      }
      &:after,
      &:before {
        display: none;
      }
      .swiper-slide {
        // width: 374px !important;
      }
      .swiper-pagination {
        display: flex;
        justify-content: center;
        align-items: center;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        margin-top: 28px;

        .swiper-pagination-bullet {
          margin: 0 3px;
          transition: all 0.2s;
          height: 6px;
          width: 6px;
        }
        .swiper-pagination-bullet-active {
          background-color: $primary-color;
          height: 10px;
          width: 10px;
        }
      }
    }
  }
}
</style>
